import request from '@/utils/request'

// 登录
export function login(data) {
    return request({
      url: '/api/authorizations',
      method: 'post',
      data
    })
}

// 获取验证码
export function getCode(data) {
    return request({
      url: '/api/verificationCodes',
      method: 'post',
      data
    })
}

// 注册
export function register(data) {
    return request({
      url: '/api/users',
      method: 'post',
      data
    })
}

// 修改密码
export function updatePwd(data) {
    return request({
      url: '/api/users/password',
      method: 'put',
      data
    })
}


// 微信登录
export function wxLogin(data) {
  return request({
    url: '/api/pc/wx/login',
    method: 'post',
    data
  })
}

